import { Routes } from '@angular/router';
import { CompaniesListComponent } from './pages/companies-list/companies-list.component';
import { RoleGuard } from '../../../core/guards/auth.guard';
import { Permission } from '../../../core/models/role-permissions.models';

export default [
	{
		path: '',
		loadComponent: () => CompaniesListComponent,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.COMPANY_VIEW],
			comeback: 'panel',
		},
	},
] as Routes;
